/*
 * Customaly horizontal scroll nav. Original work.
 * Arrow controls for overflowing collection ribbons.
 */
(function () {
  function updateHorizontalNav(nav) {
    var track = nav.querySelector('[data-cu-horizontal-nav-track]')
    var previous = nav.querySelector('[data-cu-horizontal-nav-button="-1"]')
    var next = nav.querySelector('[data-cu-horizontal-nav-button="1"]')

    if (!track || !previous || !next) {
      return
    }

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth)
    var hasOverflow = maxScroll > 4

    previous.hidden = !hasOverflow || track.scrollLeft <= 4
    next.hidden = !hasOverflow || track.scrollLeft >= maxScroll - 4
  }

  function initializeHorizontalNavs(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-horizontal-nav]').forEach(function (nav) {
      if (nav.dataset.cuHorizontalNavReady === 'true') {
        updateHorizontalNav(nav)
        return
      }

      var track = nav.querySelector('[data-cu-horizontal-nav-track]')

      if (!track) {
        return
      }

      nav.dataset.cuHorizontalNavReady = 'true'

      var updateQueued = false
      var scheduleUpdate = function () {
        if (updateQueued) {
          return
        }

        updateQueued = true
        window.requestAnimationFrame(function () {
          updateQueued = false
          updateHorizontalNav(nav)
        })
      }

      nav.querySelectorAll('[data-cu-horizontal-nav-button]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = parseInt(button.getAttribute('data-cu-horizontal-nav-button'), 10)
          var distance = Math.max(280, Math.round(track.clientWidth * 0.72))

          track.scrollBy({
            left: distance * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          })
        })
      })

      track.addEventListener('scroll', scheduleUpdate, { passive: true })

      if (typeof window.ResizeObserver !== 'undefined') {
        new ResizeObserver(scheduleUpdate).observe(track)
      } else {
        window.addEventListener('resize', scheduleUpdate)
      }

      updateHorizontalNav(nav)
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeHorizontalNavs(document)
  })

  document.addEventListener('shopify:section:load', function (event) {
    initializeHorizontalNavs(event.target)
  })
})()
